// 生产环境正式接口域名
export const API_ORIGIN =
  process.env.NODE_ENV === 'development' ? '' : 'https://api.t9299.top'

export const API_BASE =
  process.env.NODE_ENV === 'development' ? '/api' : 'https://api.t9299.top/api'

export function resolveMediaUrl(url) {
  if (!url) return ''
  if (/^https?:\/\//i.test(url) || String(url).startsWith('data:')) return url
  if (String(url).startsWith('/')) return `${API_ORIGIN}${url}`
  return `${API_ORIGIN}/${url}`
}
